<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="mg-tp10" style="width: 100%;">
            <el-tab-pane label="基本信息" name="first"></el-tab-pane>
            <el-tab-pane label="修改头像" name="second"></el-tab-pane>
            <el-tab-pane label="培训记录" name="third"></el-tab-pane>
            <el-tab-pane label="考试记录" name="fourth"></el-tab-pane>
        </el-tabs>
        <template v-if="activeName === 'first'">
            <el-form size="small" label-width="120px">
                <el-form-item label="姓名：" v-if="userInfo.userName"> {{ userInfo.userName }}</el-form-item>
                <el-form-item label="性别：" v-if="userInfo.sexText">{{ userInfo.sexText }} </el-form-item>
                <el-form-item label="账号：" v-if="userInfo.accountNo">{{ userInfo.accountNo }} </el-form-item>
                <el-form-item label="员工号：" v-if="userInfo.workNo"> {{ userInfo.workNo }} </el-form-item>
            </el-form>
        </template>
        <template v-else-if="activeName === 'second'">
            <my-upload v-bind="property" :imgUrl="avatar" @upload-success="handleSuccessAvatar" @beforeUpload="beforeUpload"
                @upload-remove="handleRemoveAvatar">
                <div slot="tip">
                    <span style="color:red;">注：请上传大小小于10M的png/jpg/jpeg文件</span>

                </div>
            </my-upload>
        </template>
        <template v-else-if="activeName === 'third'">
            <div class="main-table">
                <my-table :columns="recordTableForm.customColumns" :tableData="recordTableForm.tableData"
                    :loading="recordTableForm.isLoading"> </my-table>
            </div>
            <div class="main-pagination">
                <Pagination v-bind:child-msg="recordTableForm.page" @callFather="recordChangePage"></Pagination>
            </div>
        </template>
        <template v-else-if="activeName === 'fourth'">
            <div class="main-table">
                <my-table :columns="examTableForm.customColumns" :tableData="examTableForm.tableData"
                    :loading="examTableForm.isLoading"> </my-table>
            </div>
            <div class="main-pagination">
                <Pagination v-bind:child-msg="examTableForm.page" @callFather="examChangePage"></Pagination>
            </div>
        </template>
    </div>
</template>

<script>
import myUpload from '@/components/myUpload.vue';
import Pagination from '@/components/Pagination'
import MyTable from '@/components/myTable.vue';
import studyApi from '@/api/onlineTraining/studyRec';
import { baseInfo, editAvatar } from '@/api/userMG.js'
import { myExamRecordPage } from '@/api/exam.js'
import store from '../../vuex/store';
export default {
    components: {
        myUpload,
        MyTable,
        Pagination
    },
    data () {
        return {
            activeName: 'first',
            avatar: this.$store.state.userInfo.avatar || '',
            property: {
                config: {
                    customAction: "/api/file/upload", // 替换成你的上传地址
                    accept: '.png,.jpg,jpeg',
                    listType: 'picture',
                    showFileList: false,
                },
            },
            userInfo: {
                accountNo: "",
                sex: "",
                sexText: "",
                userName: "",
                workNo: "",
            },
            recordTableForm: {
                customColumns: [
                    { label: '课程名称', prop: 'course', formatter: (item) => { return item.courseName } },
                    { label: '学习开始时间', prop: 'startStudyTime' },
                    { label: '学习时长', prop: 'studyTimesText' },
                    { label: '是否合格', prop: 'passSign', formatter: (item) => { return item ? '合格' : '不合格' } },
                ],
                tableData: [

                    // ...其他数据
                ],
                isLoading: false,
                page: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                }
            },
            examTableForm: {
                customColumns: [
                    { label: '考试名称', prop: 'examName' },
                    { label: '考试日期', prop: 'examStartTime' },
                    { label: '考试得分', prop: 'examScore' },
                ],
                tableData: [

                    // ...其他数据
                ],
                isLoading: false,
                page: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                }
            },
        };
    },
    created () {
        this.getBasic();
        this.getRecordPage()
        this.getmyExamRecordPage()
    },
    methods: {
        async getBasic () {
            const res = await baseInfo();
            if (res.code === 200) {
                this.userInfo = res.data;
            }
        },
        handleClick (tab, event) {
            console.log(tab, event);
        },
        beforeUpload (rawFile, fun) {
            const get = _ => {
                if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg')) {
                    this.$store.state.loading = false;
                    this.$message({ message: '请上传正确的格式！', type: 'error' })
                    return false;
                } else if (rawFile.size / 1024 / 1024 > 10) {
                    this.$store.state.loading = false;
                    this.$message({ message: '超过10MB上传大小！', type: 'error' })
                    return false;
                }
                return true;
            };
            fun(get());
        },
        async handleSuccessAvatar (data, file) {
            this.avatar = envConfig.NODE_IMG_API + data.data.fileKey;
            this.$store.state.loading = false;
            const res = await editAvatar({ avatar: this.avatar });
            console.log(res);
            if (res.code === 200) {
                this.$message({ message: '修改成功', type: 'success' });
                this.$store.commit('setUserInfo', res.data)

            }
        },
        handleRemoveAvatar (file, fileList) {
            this.avatar = ''
        },


        async getRecordPage () {
            this.recordTableForm.isLoading = true;
            const params = {
                pageNum: this.recordTableForm.page.pageNum,
                pageSize: this.recordTableForm.page.pageSize,
                userId: store.state.userInfo.userId
            };
            const res = await studyApi.studyRecPage(params);
            this.recordTableForm.isLoading = false;
            this.recordTableForm.tableData = res.data.records;
            this.recordTableForm.page.total = res.data.total;
        },
        recordChangePage (parm) {
            this.recordTableForm.page.pageNum = parm.currentPage;
            this.recordTableForm.page.pageSize = parm.pageSize;
            this.getRecordPage()
        },
        async getmyExamRecordPage () {
            this.examTableForm.loading = true;
            const params = {
                pageNum: this.examTableForm.page.pageNum,
                pageSize: this.examTableForm.page.pageSize,
            };
            const res = await myExamRecordPage(params);
            this.examTableForm.isLoading = false;
            this.examTableForm.tableData = res.data.records;
            this.examTableForm.page.total = res.data.total;
        },
        examChangePage (parm) {
            this.examTableForm.page.pageNum = parm.currentPage;
            this.examTableForm.page.pageSize = parm.pageSize;
            this.getmyExamRecordPage()

        },
    }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/system/personalCenter.vue